<template>
  <basic-container style="font-family: fangSong;font-weight: bold;">
  <h1 style="font-family: fangSong;font-weight: bold;">添加客户档案信息</h1>
  <el-form ref="form" :model="formData" label-width="100px">
    <el-row>
      <el-col :span="12" v-for="item in column" :key="item.prop">
        <el-form-item v-if="!item.hide" :label="item.label" :prop="item.prop">
          <el-input v-if="item.type === 'input'" v-model="formData[item.prop]" :placeholder="item.placeholder"></el-input>
          <el-select v-else-if="item.type === 'select'" filterable v-model="formData[item.prop]">
            <el-option v-for="option in item.dicData" :key="option.value" :label="option.label"
              :value="option.value"></el-option>
          </el-select>
          <el-date-picker v-else-if="item.type === 'datetime'" v-model="formData[item.prop]"
            :value-format="item.valueFormat" :format="item.format" type="datetime"></el-date-picker>
        </el-form-item>
      </el-col>
      <!-- 上传图片 -->
      <el-col :span="24">
        <el-form-item :label="column[17].label">
          <!-- 前期照片 -->
          <el-upload :multiple="true" action="#" :accept="formData.previousPhoto.accept"
            :file-list="formData.previousPhoto" :http-request="fnUploadWheelsImgs('previousPhoto')"
            :show-file-list="false">
            <!-- 上传成功后回显 -->
            <div v-if="'' != formData.previousPhoto" class="el-upload el-upload--picture-img upload-container">
              <div class="upload-item"  v-for="describeImg of formData.previousPhoto" :key="describeImg.label">
                <img :src="describeImg.value"
                  style="width: 100px; height: 100px; border: 1px dashed #ccc; border-radius: 6px; text-align: center; line-height: 100px; cursor: pointer;">
                <a style="margin-left: 20px" @click.stop="deleteImg(describeImg.label)">删除</a>
              </div>
              <div class="el-upload el-upload--car-two"
                style="width: 100px; height: 100px; border: 1px dashed #ccc; border-radius: 6px; text-align: center; line-height: 100px; cursor: pointer;">
                <i class="el-icon-plus"></i>
              </div>
            </div>
            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item :label="column[18].label">
          <!-- 中期照片 -->
          <el-upload :multiple="true" action="#" :accept="formData.midTermPhoto.accept" :file-list="formData.midTermPhoto"
            :http-request="fnUploadWheelsImgs('midTermPhoto')" :show-file-list="false">
            <!-- 上传成功后回显 -->
            <div v-if="'' != formData.midTermPhoto" class="el-upload el-upload--picture-img upload-container">
              <div class="upload-item" v-for="describeImg of formData.midTermPhoto" :key="describeImg.label">
                <img :src="describeImg.value"
                  style="width: 100px; height: 100px; border: 1px dashed #ccc; border-radius: 6px; text-align: center; line-height: 100px; cursor: pointer;">
                <a style="margin-left: 20px" @click.stop="deleteImg(describeImg.label)">删除</a>
              </div>
              <div class="el-upload el-upload--car-two"
                style="width: 100px; height: 100px; border: 1px dashed #ccc; border-radius: 6px; text-align: center; line-height: 100px; cursor: pointer;">
                <i class="el-icon-plus"></i>
              </div>
            </div>
            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item :label="column[19].label">
          <!-- 完工照片 -->
          <el-upload :multiple="true" action="#" :accept="formData.completionPhoto.accept"
            :file-list="formData.completionPhoto" :http-request="fnUploadWheelsImgs('completionPhoto')"
            :show-file-list="false">
            <!-- 上传成功后回显 -->
            <div v-if="'' != formData.completionPhoto" class="el-upload el-upload--picture-img upload-container">
              <div class="upload-item" v-for="describeImg of formData.completionPhoto" :key="describeImg.label">
                <img :src="describeImg.value"
                  style="width: 100px; height: 100px; border: 1px dashed #ccc; border-radius: 6px; text-align: center; line-height: 100px; cursor: pointer;">
                <a style="margin-left: 20px" @click.stop="deleteImg(describeImg.label)">删除</a>
              </div>
              <div class="el-upload el-upload--car-two"
                style="width: 100px; height: 100px; border: 1px dashed #ccc; border-radius: 6px; text-align: center; line-height: 100px; cursor: pointer;">
                <i class="el-icon-plus"></i>
              </div>
            </div>
            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
      </el-col>
    </el-row>
    <el-col :span="24" class="footers">
      <el-form-item>
        <el-button type="primary" @click="submitForm">提交</el-button>
        <el-button @click="resetForm">重置</el-button>
      </el-form-item>
    </el-col>
  </el-form>
  </basic-container>
</template>

<script>
import { DIC } from "@/const/dic";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";
import {
  addCustomerInfo,
} from "@/api/salesCloud/customerFile";
export default {
  data() {
    return {
      tableLoading: false,
      formData: {
        initialNumber: '',
        customerName: '',
        customerPhone: '',
        signingTime: '',
        kingDeeNumber: '',
        projectAddress: '',
        signingType: '',
        systemType: '',
        salesman: '',
        signContract: '',
        contractPrice: '',
        constructionScheduling: '',
        progressExplanation: '',
        reporting: '',
        completionTime: '',
        warrantyPeriod: '',
        previousPhoto: [],
        midTermPhoto: [],
        completionPhoto: [],
        remarks: '',
      },
      column: [
        {
          label: "初期编号",
          prop: "initialNumber",
          type: "input",
          width: "190",
          viewVisdiplay: false,
          span: 13,
        },
        {
          label: "客户姓名",
          prop: "customerName",
          
          type: "input",
          span: 13,
        },
        {
          label: "客户电话",
          prop: "customerPhone",
          
          type: "input",
          span: 13,
        },
        {
          label: "签单时间",
          prop: "signingTime",
          type: "datetime",
          valueFormat: "timestamp",
          format: "yyyy-MM-dd HH:mm:ss",
          span: 13,
        },
        {
          label: "金蝶系统编号",
          prop: "kingDeeNumber",
          width: "150",
          type: "input",
          span: 13,
        },
        {
          label: "项目地址",
          placeholder: "请输入详细地址",
          prop: "projectAddress",
          type: "input",
          formsolt: true,
          
          /* formatter: function (row) {
            let a = row.provinceName + row.cityName + row.areaName + row.address;
            if (a != 0) {
              return a;
            }
          }, */
          span: 18,
        },
        // 签约类型signing_type
        {
          label: "签约类型",
          prop: "signingType",
          type: "select",
          
          dicData: DIC.SIGINING_TYPE,
          span: 13,
        },
        // 系统类型system_types
        {
          label: "系统类型",
          prop: "systemType",
          type: "select",
          
          dicData: DIC.SYSTEM_TYPES,
          span: 13,
        },
        // salesman业务员
        {
          label: "业务员",
          prop: "salesman",
          type: "input",
          
          span: 13,
        },
        // 是否已经签订合同sign_contract
        {
          label: "是否签订合同",
          prop: "signContract",
          type: "select",
          
          dicData: DIC.SIGIN_CONTRACT,
          span: 13,
        },
        // contract_price合同价格
        {
          label: "合同价格",
          prop: "contractPrice",
          type: "input",
          
          span: 13,
        },
        // 施工进度construction_scheduling
        {
          label: "施工进度",
          prop: "constructionScheduling",
          type: "select",
          
          dicData: DIC.CONSTRUCTION_SCHEDULING,
          span: 13,
        },
        // progress_explanation具体进度阐述
        {
          label: "具体进度阐述",
          prop: "progressExplanation",
          type: "input",
          span: 13,
        },
        // 是否报完工reporting
        {
          label: "是否报完工",
          prop: "reporting",
          type: "select",
          
          dicData: DIC.REPORTING,
          span: 13,
        },
        //完工时间completion_time
        {
          label: "完工时间",
          prop: "completionTime",
          type: "datetime",
          valueFormat: "timestamp",
          format: "yyyy-MM-dd HH:mm:ss",
          span: 13,
        },
        //质保期warranty_period
        {
          label: "质保期",
          prop: "warrantyPeriod",
          type: "select",
          
          dicData: DIC.WARRANTY_PERIOD,
          span: 13,
        },

        // 备注remarks
        {
          label: "备注",
          prop: "remarks",
          type: "input",
          span: 13,
        },
        // 前期照片previous_photos
        {
          label: "前期照片",
          prop: "previousPhoto",
          type: "upload",
          accept: "image/jpeg,image/jpg,image/png",
          tip: "只能上传jpg/png文件，且不超过500kb",
          hide: true,
        },
        // 中期照片mid_term_photos
        {
          label: "中期照片",
          prop: "midTermPhoto",
          type: "upload",
          accept: "image/jpeg,image/jpg,image/png",
          tip: "只能上传jpg/png文件，且不超过500kb",
          hide: true,
        },
        //完工照片completion_photos
        {
          label: "完工照片",
          prop: "completionPhoto",
          type: "upload",
          accept: "image/jpeg,image/jpg,image/png",
          hide: true,
        }
      ],
    };
  },
  methods: {
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 复制 formData，避免直接修改原数据
          let formData = { ...this.formData };

          // 处理图片数据
          formData.previousPhotos = formData.previousPhoto.map((img) => img.value).join(',');
          formData.midTermPhotos = formData.midTermPhoto.map((img) => img.value).join(',');
          formData.completionPhotos = formData.completionPhoto.map((img) => img.value).join(',');
          // TODO: 提交表单数据
          this.formData = formData;
          this.$confirm("确认新增提交？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
          addCustomerInfo(this.formData).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "添加成功",
                type: "success",
              });
            //重置表单
              this.resetForm();
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消新增",
          });
        });
        } else {
          console.log('表单验证失败！');
        }

      });
    },
    resetForm() {
      this.$refs.form.resetFields();
    },
    fnUploadWheelsImgs(prop) {
      return (option) => {
        getAliyunPublicToken().then((res) => {
          let data = JSON.parse(res.data);
          let client = new oss({
            region: data.point,
            endPoint: data.point,
            accessKeyId: data.accessKeyId,
            accessKeySecret: data.accessKeySecret,
            Expiration: data.expiration,
            bucket: data.bucketName,
            stsToken: data.securityToken,
          });
          const storeAs = md5(option.file.name) + new Date().getTime();

          // 确保 formData[prop] 是一个数组
          if (!Array.isArray(this.formData[prop])) {
            this.formData[prop] = [];
          }

          client
            .multipartUpload(storeAs, option.file, {})
            .then((results) => {
              let res = results.res.requestUrls[0].split("?");
              this.formData[prop].push({ label: storeAs, value: res[0] });
              // console.log(this.formData[prop]);
            })

            .catch((err) => {
              console.error(err);
            });
        });
      };
    },

    deleteImg(label) {
      for (const prop of Object.keys(this.formData)) {
        if (Array.isArray(this.formData[prop])) {
          this.formData[prop] = this.formData[prop].filter((img) => img.label !== label);
        }
      }
    },

    beforeUpload(file) {
      // 上传文件之前的校验
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      const isLt500KB = file.size / 1024 < 500;

      if (!isJPG) {
        this.$message.error('只能上传jpg/png文件！');
      }
      if (!isLt500KB) {
        this.$message.error('文件大小不能超过500KB！');
      }

      return isJPG && isLt500KB;
    },
  },
};
</script>
<style lang="scss" scoped>
.footers {
  text-align: center;
}
.upload-container {
  display: flex;
  flex-wrap: wrap;
}

.upload-item {
  flex: 0 0 auto;
  margin-right: 10px; /* 调整图片之间的间距 */
  margin-bottom: 10px; /* 调整行之间的间距 */
}
// .el-upload横向布局超出换行
</style>